<script setup lang="ts">
const productContent = useProductContentStore()

const personalization = usePersonalizationStore()

const handleNextArticleClick = async () => {
  if (
    productContent.activeArticle?.id &&
    productContent.nextArticle?.frontendHref
  ) {
    personalization.addArticleToReadHistory(
      productContent.activeArticle.id,
      true,
    )
    await navigateTo(productContent.nextArticle.frontendHref)
  }
}
</script>

<template>
  <div
    class="px-6 md:px-0 flex items-center justify-between md:justify-start"
  >
    <UContentFreeLabel
      v-if="productContent.activeSubject?.showFreeLabel"
      class="md:hidden"
    />
    <UButtonNew
      v-if="productContent.nextArticle?.id"
      pill
      theme="light"
      class="md:mr-6"
      @click="handleNextArticleClick"
    >
      <template #prepend>
        <u-icon name="arrow-down" />
      </template>
      Neste
    </UButtonNew>
    <span
      class="hidden grow truncate whitespace-nowrap text-button-medium-button-text-regular md:block"
    >
      {{ productContent.nextArticle?.title }}</span
    >
    <UContentFreeLabel
      v-if="productContent.activeSubject?.showFreeLabel"
      class="hidden md:block"
    />
  </div>
</template>
